import { isFalsy } from 'utility-types';

export const setPreventDisplyForWeek = (localStorageItemName: string, itemData) => {
  const date = new Date();
  const today = date.getDate();
  date.setDate(today + 7);

  localStorage.setItem(
    localStorageItemName,
    JSON.stringify({
      data: itemData,
      expires: date
    })
  );
};

export const checkIsPreventedDisplyForWeek = (localStorageItemName: string): boolean => {
  const allowModalData = JSON.parse(localStorage.getItem(localStorageItemName) ?? '{}');

  const { expires } = allowModalData;
  const today = new Date();
  const expiredDay = new Date(expires);

  let isModalAllowed: boolean = true;
  if (!isFalsy(expires)) {
    isModalAllowed = Boolean(today > expiredDay);

    if (today >= expires) {
      localStorage.removeItem(localStorageItemName);
    }
  }
  return !isModalAllowed;
};
